import { defineCollectionStore } from '@/utils/defineCollectionStore';
import { makeAPIMap } from '@/utils/makeAPIMap';

export const useNeighborhoodsStore = defineCollectionStore({
    id: 'neighborhoods',
    endpoint: '/api/neighborhoods',
    dataKey: 'neighborhoods',
    mapKey: 'neighborhoodsMap',
    errorLabel: 'Fetch Neighborhoods Error: ',
    fetchName: 'fetchNeighborhoods',
    archive: {
        toggleName: 'updateNeighborhoods',
        archivedDataKey: 'archivedNeighborhoodsData',
        archivedMapKey: 'archivedNeighborhoodsMap',
        archivedFetchName: 'fetchArchivedNeighborhoods',
        // Verbatim quirk: falls back to the live endpoint when no year is passed.
        archivedEndpoint: (year) => (year ? `/api/archive/${year}/neighborhoods` : '/api/neighborhoods'),
        getters: {
            neighborhoodsData: { role: 'data', fallback: () => [] },
        },
    },
    // `neighborhoods` and `archivedNeighborhoodsData` both start `null` (not `[]`), and the store carries
    // an unused `year` field that the old store declared but never wrote to. `archivedNeighborhoodsData`
    // matters: the factory default for a non-wrapRecords archived key is `[]`, but the old getter's
    // `!== null` check treats `[]` as present data — since `/api/archive/<year>/neighborhoods` is a dead
    // endpoint, that would permanently show an empty archive list instead of falling through to the live
    // neighborhoods list.
    extraState: () => ({
        neighborhoods: null,
        archivedNeighborhoodsData: null,
        year: null,
    }),
    getters: {
        // Verbatim quirk: this getter is NOT archive-aware (always reads the live map, even when archived).
        getNeighborhoodsMap(state: any) {
            return state.neighborhoodsMap || {};
        },
    },
    extraActions: {
        // Verbatim quirk: sorts by fields.Name and only assigns when data is present; ignores its `year` arg.
        async fetchNeighborhoods(this: any) {
            try {
                const res: any = await $fetch('/api/neighborhoods');
                if (res.data) {
                    const hoods = res.data;
                    hoods.sort((a: any, b: any) => {
                        if (a.fields.Name < b.fields.Name) return -1;
                        if (a.fields.Name > b.fields.Name) return 1;
                        return 0;
                    });
                    this.neighborhoods = hoods;
                    this.neighborhoodsMap = makeAPIMap(hoods);
                }
                this.version = res?.meta?.version ?? null;
            } catch (e) {
                console.log('Fetch Neighborhoods Error: ', e);
            }
        },
    },
});
